/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum InvestmentDataSectionType {
  Primary = 'Primary',
  ExpandedArea = 'ExpandedArea'
}
